import { TECHNOLOGY } from '@constants/provider';

export function normalizeTechnology(technology?: string): TECHNOLOGY {
    return technology?.toUpperCase() as TECHNOLOGY;
}

export function filterOut4GWhen5GExists<T extends { technology: string }>(offers: T[]): T[] {
    const has4G = offers.some((offer) => offer.technology === TECHNOLOGY.BOX_4G);
    const has5G = offers.some((offer) => offer.technology === TECHNOLOGY.BOX_5G);

    return has4G && has5G ? offers.filter((offer) => offer.technology !== TECHNOLOGY.BOX_4G) : offers;
}
